import * as yup from "yup";

export const RemittanceYearToDateSetupValidationSchema = yup.object().shape({
	year: yup.string().required("Year is required"),
});
